import Constants from '@/Constants';
import List from '@/models/List';
import { useGet } from './useGet';

interface Props {
    id: number;
}

export const useCourse = ({ id }: Props) => {
    const { data: course } = useGet<List>(`${Constants.LMS_COURSES_URI}/${id}`);

    return { course };
};
